<template>
  <div>
    <h1>Consent</h1>
    <div>
      <p>
        We want you to use this pass to get product benefits, coupons and Keep
        third party actions up to date. For this we collect once or on your
        change request preferences, which can be changed using a pseudonymized
        codes (no personal reference) can be saved. To you We send information
        about innovations in irregular Intervals push notifications.
      </p>
      <div class="consent-container">
        <div class="consent-checkbox-container">
          <input
            v-model="checked"
            type="checkbox"
            name="checkbox"
            class="consent-checkbox"
          />
        </div>
        <span class="consent-text" v-on:click="handleChecked"
          >I consent to the receipt of advertising communication from the areas
          of fashion, sport, living, technology etc. in the form of push
          notifications. You can find more information about the voucher pass
          here.</span
        >
      </div>
      <Button
        label="Select preferences"
        :disabled="!checked"
        v-on:click="submit"
      />
      <p>
        I can withdraw my consent at any time by deleting my passport or
        deactivate the push notifications on the back of the passport. By
        withdrawing consent, the legality of the the processing until consent
        has been withdrawn is not affected.
      </p>
      <p>
        Further information on data protection and revocation can be found at
        <a
          href="https://www.mastercard.us/en-us/about-mastercard/corp-responsibility/commitment-to-privacy.html"
          >Legal Notice</a
        >.
      </p>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";

export default {
  components: {
    Button
  },
  data: () => {
    return { checked: false };
  },

  methods: {
    submit() {
      this.$router.push("register");
    },

    handleChecked() {
      this.checked = !this.checked;
    }
  }
};
</script>
<style scoped>
.consent-container {
  display: flex;
  flex-direction: row;
  max-width: 300px;
}

.consent-checkbox-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
  margin-left: 4px;
}
.consent-checkbox {
  font-size: x-large;
}

.consent-text {
  font-size: 14px;
  font-style: italic;
}
</style>
